





























import Vue from "vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    ConversionButton,
  },
  methods: {
    goToNoticePage() {
      this.$nuxt.$router.push("/profiles/notice/skill_tag")
    },
    goToEditPage() {
      this.$nuxt.$router.push("/profiles/edit/skill_tag")
    },
  },
})
